import {findClosestElementByClass} from "../helpers/dom/closest";

export const cookiesBanner = {
    banner: function () {
        const closeButtons = document.querySelectorAll('.banner-b2b__close');
        if(!closeButtons) return;

        closeButtons.forEach(el => {
            const parentBanner = findClosestElementByClass(el, 'banner-b2b');
            const parentBannerID = parentBanner.getAttribute('id');
            const placeholder = findClosestElementByClass(el, 'placeholder');
            const elementAttribute = el.getAttribute('data-close');
            const cookieValue = this.getCookie(parentBannerID);

            this.checkCookie(cookieValue, placeholder);

            el.addEventListener('click', _ => {
                placeholder.style.display = "none";
                this.setCookie(elementAttribute, el, parentBannerID);
            });
        });
    },
    setCookie: function (exDays, el, parentBannerID) {
        let date = new Date();
        let expires;
        if (exDays == 0) {
            document.cookie = `${parentBannerID}=hide` + `expires=${exDays}`;
        }
        if (exDays > 0) {
            date.setTime(date.getTime()+(exDays*24*60*60*1000));
            expires = "; expires="+date.toGMTString();
            document.cookie = `${parentBannerID}=hide` + expires;
        }
    },
    getCookie: function (name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    checkCookie: function (cookieValue, parentBanner) {
        if (cookieValue !== null) {
            parentBanner.style.display = 'none';
        }
    },
    initListeners: function () {
        this.removeCookiesActions();
    },
    removeCookiesActions: function () {
        const cookiesRemoveActionBtns = document.querySelectorAll('[data-remove-cookie]');
        if (!cookiesRemoveActionBtns.length) return;

        cookiesRemoveActionBtns.forEach(
            cookieBtn => cookieBtn
                .addEventListener('click', _ => this.removeCookieByName(cookieBtn.dataset.removeCookie))
        )
    },
    removeCookieByName: function (name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
};
